<template>
    <div class="auto">
        <div class="tips">
            <div class="title">异地接单打印</div>
            <div class="sub-title">YI DI JIE DAN DA YIN</div>
            <div class="labels">
                <div class="label-item">1、智慧云端，只要有电源有网络就可使用。</div>
                <div class="label-item">2、无需复杂配置，打印不受距离和场所限制。</div>
                <div class="label-item">3、云打印可使用在餐饮外卖以外领域，如鲜花、商超、医疗、零售等场景，匹配更广泛的市场需求。</div>
            </div>
        </div>
        <img src="/static/img/cloud.png" />
    </div>
</template>


<script>
export default {
    data() { return {} }

}
</script>


<style scoped>
.auto {
    display: flex;
    padding: 80px 240px;
}

.tips {
    text-align: left;
    flex: 1;
}

.title {
    font-size: 60px;
}

.sub-title {
    color: #e2e2e2;
    font-size: 28px;
}

.labels {
    margin-top: 30px;
    color: #999;
}

.label-item {
    font-size: 18px;
}

.label-item+.label-item {
    margin-top: 20px;
}
</style>
<style>
.hoverSize .el-col {
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// homePage0.vue?20598be2